<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
  Rediger bruger
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<form [formGroup]="userFormGroup" (ngSubmit)="save()">
  <mat-dialog-content>
    <ng-container>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Navn</mat-label>
          <input matInput placeholder="Navn på brugeren" maxlength="75" formControlName="name" required value="" />
          @if (userFormGroup.controls.name.invalid) {
            <mat-error>Indtast venligst navn</mat-error>
          }
        </mat-form-field>
      </div>
      <adm-dep-address-typeahead
        style="width: 100%"
        [parentFormGroup]="userFormGroup"
        [initialAddress]="initialAddress()"
        [label]="'Leveringsadresse'"
        [addressWithoutDARValidation]="false"
        [hideRequiredMarker]="true"
        (addressSelected)="selectAddress($event)" />
      <div class="form-row">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput placeholder="Brugerens email adresse" maxlength="100" formControlName="email" email />
          @if (userFormGroup.controls['email'].invalid) {
            <mat-error>{{ getErrorMessage('emailAddress') }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <div class="grid-cols">
          <adm-country-code-selector [formItem]="userFormGroup.controls.countryCode" />
          <adm-phone-number-input [formItem]="userFormGroup.controls.phoneNumber" [countryCode]="userFormGroup.controls.countryCode" />
        </div>
      </div>
      <div class="form-row">
        @let chargingUserValue = this.chargingUser();
        @let departmentId = chargingUserValue?.departmentId;
        <adm-dep-typeahead
          [organizationId]="chargingUserValue?.organizationId ?? null"
          [departmentId]="departmentId !== null && departmentId !== undefined ? departmentId.toString() : null"
          (itemSelected)="departmentSelected($event)"
          [resetTrigger]="resetDepartmentTrigger()" />
      </div>
      <div class="form-row">
        <mat-form-field>
          <mat-label>ID</mat-label>
          <input matInput placeholder="Brugerens id" maxlength="100" formControlName="id" id />
          @if (userFormGroup.controls['id'].invalid) {
            <mat-error>{{ getErrorMessage('id') }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-label class="bold">Har brugeren firmabil</mat-label>
        <mat-radio-group formControlName="userHasCompanyCar" name="userHasCompanyCar">
          <mat-radio-button [value]="true">
            <span [class.bold]="userFormGroup.controls.userHasCompanyCar.value === true">Ja</span>
          </mat-radio-button>
          <mat-radio-button [value]="false">
            <span [class.bold]="userFormGroup.controls.userHasCompanyCar.value === false">Nej</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
      @if (this.userFormGroup.controls.userHasCompanyCar.value !== null) {
        <div class="form-row">
          @if (this.userFormGroup.controls.userHasCompanyCar.value === true) {
            <adm-g4-agreement-number [control]="this.userFormGroup.controls.agreementNumber" />
          } @else {
            <div>
              <adm-g4-account-number [control]="this.userFormGroup.controls.invoicingAccountNumber" />
              <mat-hint class="tiny-text mat-whitespace-fix">
                Indtastet kontonr bliver brugt til at fakturere alt forbrug for brikkerne tilknyttet brugeren
              </mat-hint>
            </div>
          }
        </div>
      }
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button mat-dialog-close>Annuller</button>
    @if (userFormGroup) {
      <button class="actions__button" type="submit" mat-flat-button color="primary" [disabled]="userFormGroup.invalid">Gem</button>
    }
  </mat-dialog-actions>
</form>
